import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

const NOTICE_VERSION = "1.0-2026-01";

export default function Consent() {
    const nav = useNavigate();
    const { refresh } = useAuth();
    const [agree, setAgree] = useState(false);
    const [loading, setLoading] = useState(false);

    const submit = async () => {
        if (!agree) return;
        setLoading(true);
        try {
            await api.post("/consent", { notice_version: NOTICE_VERSION });
            await refresh();
            nav("/");
        } catch {
            toast.error("Could not record consent");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <div className="speakup-card p-6 md:p-8" data-testid="consent-screen">
                <h1 className="display text-[26px] md:text-[30px]">A quick privacy note</h1>
                <p className="text-[var(--speakup-text-muted)] mt-2">
                    Notice version <span className="tabular">{NOTICE_VERSION}</span>
                </p>

                <div className="mt-6 space-y-4 text-[15px] leading-relaxed">
                    <p>
                        <strong>What we collect:</strong> your phone number, optional email and name, your voice clip
                        when you tap the mic, the complaint text you share, and any reply you forward to us.
                    </p>
                    <p>
                        <strong>Why:</strong> to draft your formal complaint, tell you exactly whom to send it to,
                        and remember where you are in the escalation ladder.
                    </p>
                    <p>
                        <strong>How long:</strong> voice clips are auto-deleted after 30 days; everything else stays
                        while your complaint is live. You can delete your data at any time from <em>Account</em>.
                    </p>
                    <p>
                        <strong>What we won't do:</strong> we will <em>never</em> send email to your bank ourselves
                        and we won't connect to your inbox. You always send from your own email.
                    </p>
                </div>

                <label
                    className="flex items-start gap-3 mt-7 cursor-pointer select-none"
                    data-testid="consent-checkbox-wrap"
                >
                    <input
                        type="checkbox"
                        checked={agree}
                        onChange={(e) => setAgree(e.target.checked)}
                        className="mt-1 h-5 w-5 accent-[var(--speakup-red)]"
                        data-testid="consent-checkbox"
                    />
                    <span className="text-[15px]">
                        I have read and understood the above. Please proceed.
                    </span>
                </label>

                <button
                    onClick={submit}
                    disabled={!agree || loading}
                    data-testid="consent-continue-btn"
                    className="mt-6 h-12 px-6 rounded-[12px] text-white font-semibold disabled:opacity-60"
                    style={{ background: "var(--speakup-red)" }}
                >
                    {loading ? "Saving…" : "Agree and continue"}
                </button>
            </div>
        </Layout>
    );
}
